import {Component, inject, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DomSanitizer, SafeUrl, Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import { User, Box, Subcategory, BoardType, BoardStrength, Price, PaperType, PrintType, BoxType, Preset, ERROR_TITLE, Variant, ENVIRONMENT } from '@company-box/models';
import { BoxTemplateInput, CookieService, DesignService, ProjectService, UserService } from '@company-box/services';
import { ConfirmationModalComponent, Fractions, LoadingModalComponent, prefetchUnityBuilder, getPricingPaperType } from '@company-box/utils';
import cryptoJs from 'crypto-js';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NGXLogger } from 'ngx-logger';
import { LoginModalComponent } from '../../features/layouts/login-modal/login-modal.component';
import { CommonModule, JsonPipe } from '@angular/common';
import { NotFoundModalComponent } from '../../features/layouts/not-found-modal/not-found-modal.component';
import { PrintingTableComponent } from './printing-table/printing-table.component';
import { ERROR_BODY } from '@company-box/models';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { CBBoxService } from '../../services/cb-box.service';
import { CheckoutService } from "@company-box/services";
import { NavigationService } from '../../services/navigation.service';

declare var window: any;

@Component({
  selector: 'app-box-options',
  templateUrl: './box-options.component.html',
  styleUrls: ['./box-options.component.scss'],
  imports: [
    CommonModule,
    LoadingModalComponent,
    LoginModalComponent,
    NotFoundModalComponent,
    PrintingTableComponent,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    AlertComponent
  ]
})
export class BoxOptionsComponent implements OnInit {

  @ViewChild('login', { static: false }) loginModal!: TemplateRef<any>;
  @ViewChild('login1', { static: false }) loginModal1!: TemplateRef<any>;
  @ViewChild('loginToSave', { static: false }) loginToSaveModal!: TemplateRef<any>;
  @ViewChild('notFoundModal', { static: false }) notFoundModal!: TemplateRef<any>;
  environment = inject(ENVIRONMENT)
  designOnline3dEnabled = !!this.environment.features?.designOnline3d;
  public pageLoaded: boolean = false;
  public type: any;
  public templateLoading = false;

  private user: User | undefined;

  updating: boolean = false;
  public presets: Preset[] = [];
  box: Box | undefined;
  public subcategoryCode: string = '';
  public categoryCode: string = '';

  selectedImage = 0;
  mainGalleryImageURL: string = '';
  private titleService = inject(Title);
  private _selectedSubcategory: Subcategory | undefined;
  get selectedSubcategory(): Subcategory | undefined {
    return this._selectedSubcategory;
  }
  set selectedSubcategory(subcategory: Subcategory | undefined) {
    this._selectedSubcategory = subcategory;
    const productName = (subcategory?.name ?? '').replace(/<[^>]*>/g, '');
    if (productName) {
      this.titleService.setTitle(`${productName} | Select Your Size & Specs | ${this.environment.config.title}`);
    }
  }
  infoDataRows: any[] = [];
  noteDataRows: any[] = [];
  selectedBoardType: BoardType | undefined;
  private boardType: BoardType | undefined;
  selectedBoardStrength: BoardStrength | undefined;

  length = 0;
  lengthFraction = 0;
  lengthWhole = 0;
  width = 0;
  widthFraction = 0;
  widthWhole = 0;
  depth = 0;
  depthFraction = 0;
  depthWhole = 0;

  prices: Price[] = [];
  paperTypes: PaperType[] = [];

  subcategories: Subcategory[] = [];
  subcategoriesFailed: boolean = false;
  selectedPaperType: PaperType | undefined;
  selectedPrintType: PrintType | undefined;
  selectedPreset: Preset | undefined;
  gloss = false;
  twoSided = false;
  insideOnly = false;
  noPrinting = false;
  expedited = false;

  quantityError: string | undefined;
  quantity: number = 0;
  quantities: number[] = [];
  standardQuantities = [1, 10, 25, 50, 100, 250, 500, 1000, 1500, 2000, 5000, 10000, 12000];
  luxeQuantities = [1, 10, 25, 50, 100, 250, 500, 1000, 2000, 5000, 10000, 12000];

  hasViolationErrors = false;
  violations: any[] = [];
  presetMatches: Preset[] = [];
  customSizeIncrease: number | undefined;

  selectedPrice: Price | undefined;
  showCustomQuantity: boolean = false;
  private design: any;
  private designNamed: boolean = false;

  private modal: BsModalRef|undefined;
  subcategoryImages: [] = [];
  printing: string | string[] = '';
  printingOptions: any[] = [];
  standard: boolean = true;
  noprint: boolean = false;
  luxe: boolean = false;
  material: string = '';
  innerMaterial: string = '';
  outerMaterial: string = '';
  materialOptions: any[] = [];
  outerMaterialOptions: any[] = [];
  innerMaterialOptions: any[] = [];
  finish = 'Matte';
  finishOptions = ['Matte'];
  quantityArrayIndex: number = -1;
  boardStrength: BoardStrength | undefined;
  paperType: PaperType | undefined;
  preset: Preset | undefined;
  allowCustomSizes: boolean = false;
  displayPremiumWhite: boolean = false;
  displayWhite: boolean = false;
  displayKraft: boolean = false;
  displaySecondaryWhite: boolean = false;
  displaySecondaryKraft: boolean = false;
  displayTwoSided: boolean = false;
  displayLuxe: boolean = false;
  displayNoprint: boolean = false;
  displayStandard: boolean = false;
  allowCustomSample: boolean = false;
  displayFinish: any;
  suggestedPreset: any;
 customSizeActive = false;
  customSizeEntered = false;
  presetSuggestion = false;
  depthError: any;
  paperTypeId: string = '';
  boardTypeList: BoardType[] = [];
  boardStrengthList: BoardStrength[] = [];
  isDHC = false;
  isPartition = false;
  isTape = false;
  isPizza = false;
  isTissue = false;
  isCrinkle = false;
  isLabel = false;
  isOtherProduct = false;
  isPaddedMailer = false;
  customQuantityViolation = false;
  hasVariants = false;
  variants: Variant[] = [];
  selectedVariant: Variant | undefined;

  customQuantityActive = false;
  customQuantityEntered = false;
  enteredCustomQuantity: number | string | undefined;

  public uploadDesign = false;

  public templateDownloadUrl: SafeUrl | undefined;

  boxType: BoxType | undefined;
  categoryName!: string;
  public date = new Date();

  // Other products variables
  cellLength = 0.375;
  cellWidth = 0.375;
  lengthSlots = 1;
  widthSlots = 1;
  tapeLengthOptions = [2, 4, 8, 16];
  tissueIncrementViolation = false;

  shape = 'Circle';
  shapeOptions = ['Circle', 'Oval', 'Square', 'Rectangle'];

  public downloadingTemplate = false;
  options: string = '';
  productData: any;
  productDetails: any;
  pendingUse3d = false;
  isTest: false = false;
  constructor(
    private boxService: CBBoxService,
    private route: ActivatedRoute,
    private bsModalService: BsModalService,
    private router: Router,
    private logger: NGXLogger,
    private userService: UserService,
    private designService: DesignService,
    private sanitizer: DomSanitizer,
    private checkoutService: CheckoutService,
    private navigationService: NavigationService,
    private projectService: ProjectService,
    private cookieService: CookieService) {
  }

  async ngOnInit() {
    window.scroll(0, 0);
    this.pageLoaded = false;
    prefetchUnityBuilder(this.environment.builderUrl, this.route.snapshot.params["subcategory"]);
    this.route.params.subscribe(params => {
      this.categoryCode = params['category'];
      this.subcategoryCode = params['subcategory'];
      this.navigationService.setSubcategory(this.subcategoryCode);
      this.uploadDesign = params["uploadDesign"] === "true";
    });

    await this.userService.getCurrentUser()
    .then((response: any) => {
      this.user = response;
    }).catch((error: any) => {
      console.log(error);
    });
    this.isTest = JSON.parse(this.cookieService.read('isTest') || 'false');
    if (this.isTest) {
      this.productDetails = this.readProductCookie();
    }
    // If not display header card.
    this.isPaddedMailer = this.subcategoryCode.startsWith('RPM');
    if (this.subcategoryCode === 'tape') {
      this.isOtherProduct = true;
      this.isTape = true;
      this.getTape();
    } else if (this.subcategoryCode === 'part') {
      this.isOtherProduct = true;
      this.isPartition = true;
      this.getPartition();
    } else if (this.subcategoryCode === 'tissue') {
      this.isOtherProduct = true;
      this.isTissue = true;
      this.getTissue();
    } else if (this.isCrinkleProduct(this.subcategoryCode)) {
      this.isOtherProduct = true;
      this.isCrinkle = true;
      this.getCrinkle();
    } else if (this.subcategoryCode.toLowerCase() === 'lbl') {
      this.isOtherProduct = true;
      this.isLabel = true;
      this.getLabel();
    } else if (this.subcategoryCode === 'DHC') {
      this.isDHC = true;
      this.getDHC();
    } else {
      this.isPizza = this.subcategoryCode === 'PIZ';
      this.getPresets();
    }

    if (window.loyaltylion) {
      window.loyaltylion.authenticateCustomer({
        customer: { id: this.user?.shopifyId, email: this.user?.username },
        auth: { date: this.date.toISOString(), token: this.getAuthToken() }
      });
    }
  }
  getAuthToken() {
    const date = this.date.toISOString();
    const secret = 'b3456ad863ff28b11560dce3d09e5ee0';
    const authToken = cryptoJs.SHA1(this.user?.shopifyId + date + this.user?.username + secret);

    return authToken.toString();
  }
  readProductCookie() {
    const encodedData = this.cookieService.read('productDetails');
    if (encodedData) {
      return JSON.parse(atob(encodedData));
    }
    return undefined;
  }
  goBack() {
    if (this.isPaddedMailer) {
      this.router.navigate(['/box-category'], {
        fragment: `upload=${this.uploadDesign}`
      });
    } else {
      this.router.navigate(['/box-style', this.categoryCode, this.uploadDesign]);
    }
  }

  getPresets() {

    if (this.subcategoryCode.toLowerCase().includes('snap2') && this.selectedVariant) {
      this.subcategoryCode = this.selectedVariant.code??"";
    }
    let errorAdded = false;
    this.boxService.listPresets(this.categoryCode, this.subcategoryCode)
    .then((presets: Preset[]) => {
      this.presets = presets;
      this.mainGalleryImageURL = this.presets[0]?.type?.subcategory?.images[0].location??'';
      // Sets default box photo.
      if (this.presets[0]?.type?.subcategory?.images) {
        for (const image of this.presets[0]?.type?.subcategory?.images) {
          if (image.default) {
            this.mainGalleryImageURL = image.location??'';
            break;
          }
        }
      }

      const label = this.isTest ? this.productDetails.length + ' x ' + this.productDetails.width + ' x ' + this.productDetails.depth : '';
      this.customSizeActive = this.isTest && this.productDetails.customSizeActive;
      this.customSizeEntered = this.isTest && this.productDetails.customSizeEntered;
      this.pageLoaded = true;
      if (this.subcategoryCode !== 'PIZ' && this.subcategoryCode !== 'QPME' && this.subcategoryCode !== 'WINE' && this.subcategoryCode !== 'BEER') {
        this.selectedPreset = this.isTest ? (!this.customSizeEntered ? this.presets.find(p => p.label === label) : this.presets[0]) : this.presets[0];
      } else if (this.subcategoryCode === 'PIZ' || this.subcategoryCode === 'QPME' || this.subcategoryCode === 'WINE' || this.subcategoryCode === 'BEER') {
        this.selectedPreset = this.presets[0];
      }
      this.categoryName = this.selectedPreset?.type?.description??'';
      this.selectedSubcategory = this.selectedPreset?.type?.subcategory;
      this.infoDataRows = this.selectedSubcategory?.data?.filter((value: any) => value.type === 'INFO' )??[];
      console.log(this.infoDataRows);
      this.noteDataRows = this.selectedSubcategory?.data?.filter((value: any) => value.type === 'NOTE' )??[];
      console.log(this.noteDataRows);
      this.selectedBoardType = this.selectedPreset?.type?.boardType;
      this.updatePrintingOptions();
      this.standard = true;
      this.noprint = true;
      this.luxe = false;
      this.twoSided = false;
      this.finish = 'Matte';
      this.boardTypeList = this.selectedPreset?.type?.subcategory?.boardTypes??[];
      if (this.isTest && this.customSizeEntered) {
        this.lengthWhole = this.productDetails.lengthWhole;
        this.widthWhole = this.productDetails.widthWhole;
        this.depthWhole = this.productDetails.depthWhole;
        this.lengthFraction = this.productDetails.lengthFraction;
        this.widthFraction = this.productDetails.widthFraction;
        this.depthFraction = this.productDetails.depthFraction;
      }

      this.selectedBoardType = this.boardTypeList.find(boardType => boardType.id === this.selectedPreset?.type?.boardType?.id);

      this.paperTypes = this.boxService.getPaperTypes(this.selectedSubcategory!);
      this.selectedBoardStrength = this.selectedBoardType?.boardStrengths[0];
      this.boardStrength = this.selectedBoardStrength;
      this.allowCustomSizes = this.selectedPreset?.allowCustomSizes??false;
      this.displayPremiumWhite = this.selectedPreset?.displayPremiumWhite??false;
      this.displayWhite = this.selectedPreset?.displayWhite??false;
      this.displayKraft = this.selectedPreset?.displayKraft??false;
      this.displaySecondaryWhite = this.selectedPreset?.displaySecondaryWhite??false;
      this.displaySecondaryKraft = this.selectedPreset?.displaySecondaryKraft??false;
      this.displayTwoSided = this.selectedPreset?.displayTwoSided??false;
      this.displayLuxe = this.selectedPreset?.displayLuxe??false;
      this.displayStandard = this.selectedPreset?.displayStandard??false;
      this.displayNoprint = this.selectedPreset?.displayNoprint??false;
      this.allowCustomSample = this.selectedPreset?.allowCustomSample??false;
      this.hasVariants = this.selectedPreset?.hasVariants??false;

      if (this.hasVariants) {
        this.getVariants();
      }
      this.updateForm();
      if (this.isTest) {
        this.showModal(this.loginModal1);
      }
    }, (reason: any) => {
      if (!errorAdded) {
        errorAdded = true;
        this.showModal(this.notFoundModal);
        this.logger.error(reason);
      }
    });

  }

  getDHC() {
    this.boxService.getSubcategory(this.subcategoryCode!)
    .then((subcategory: Subcategory) => {
      this.pageLoaded = true;
      this.selectedSubcategory = subcategory;
      this.standard = true;
      this.luxe = false;
      this.customSizeActive = true;
      this.customSizeEntered = false;
      this.twoSided = false;
      this.length = 8;
      this.lengthWhole = 8;
      this.width = 4;
      this.widthWhole = 4;
      this.depth = 0;
      this.presets = [];
      this.printingOptions = [];
      this.finish = 'Matte';
      this.boardTypeList = subcategory.boardTypes;
      this.selectedBoardType = this.boardTypeList[0];
      this.selectedBoardStrength = subcategory.boardTypes[0].boardStrengths[0];
      this.mainGalleryImageURL = subcategory.images[0].location??'';
      this.boardStrength = this.selectedSubcategory?.boardTypes[0].boardStrengths[0];
      this.allowCustomSizes = this.selectedSubcategory?.allowCustomSizes??false;
      this.displayPremiumWhite = this.selectedSubcategory?.displayPremiumWhite??false;
      this.displayWhite = this.selectedSubcategory?.displayWhite??false;
      this.displayKraft = this.selectedSubcategory?.displayKraft ?? false;
      this.displaySecondaryWhite = this.selectedSubcategory?.displaySecondaryWhite ?? false;
      this.displaySecondaryKraft = this.selectedSubcategory?.displaySecondaryKraft ?? false;
      this.displayTwoSided = this.selectedSubcategory?.displayTwoSided ?? false;
      this.displayLuxe = this.selectedSubcategory?.displayLuxe ?? false;
      this.displayStandard = this.selectedSubcategory?.displayStandard ?? false;
      this.allowCustomSample = this.selectedSubcategory?.allowCustomSample ?? false;

      // Sets default box photo.
      for (const image of subcategory.images) {
        if (image.default) {
          this.mainGalleryImageURL = image.location ?? '';
          break;
        }
      }

      this.updatePrintingOptions();
      this.updateMaterialOptions();
      this.listPrices();

    }, (reason: any) => {
      this.showModal(this.notFoundModal);
      this.logger.error(reason);
    });


  }

  getTape() {
    this.customSizeEntered = true;
    this.prices = [];
    this.length = 2;
    this.lengthWhole = 2;
    this.width = 3;
    this.widthWhole = 3;
    this.depth = 0;
    this.depthWhole = 0;
    this.categoryName = 'Tape';

    this.boxService.getSubcategory(this.subcategoryCode)
    .then((subcategory: Subcategory) => {

      for (const image of subcategory.images) {
        if (image.default) {
          this.mainGalleryImageURL = image.location ?? '';
          break;
        }
      }

      this.boxService.getType(this.subcategoryCode)
      .then((type: { boardType: any; }) => {
        this.selectedBoardType = type.boardType;
        this.boardType = type.boardType;
        this.type = type;
      })
      .catch(() => {
        this.showModal(this.notFoundModal);
      });
      this.selectedSubcategory = subcategory;
      this.paperTypes = this.boxService.getPaperTypes(this.selectedSubcategory);
      this.paperType = this.paperTypes[1];
      this.presets = [];
      this.selectedPreset = undefined;
      this.prices = [];
      this.allowCustomSizes = subcategory.allowCustomSizes ?? false;
      this.displayPremiumWhite = subcategory.displayPremiumWhite ?? false;
      this.displayWhite = subcategory.displayWhite ?? false;
      this.displayKraft = subcategory.displayKraft ?? false;
      this.displaySecondaryWhite = subcategory.displaySecondaryWhite ?? false;
      this.displaySecondaryKraft = subcategory.displaySecondaryKraft ?? false;
      this.displayTwoSided = subcategory.displayTwoSided ?? false;
      this.displayLuxe = subcategory.displayLuxe ?? false;
      this.displayStandard = subcategory.displayStandard ?? false;
      this.allowCustomSample = subcategory.allowCustomSample ?? false;
      this.hasVariants = subcategory.hasVariants??false;

      this.updatePrintingOptions();
      this.updateMaterialOptions();
      this.listTapePrices();

    }, (reason: any) => {
      this.showModal(this.notFoundModal);
      this.logger.error(reason);
    });
  }

  getPartition() {
    this.customSizeEntered = true;
    this.prices = [];
    this.length = 10;
    this.lengthWhole = 10;
    this.width = 10;
    this.widthWhole = 10;
    this.depth = 10;
    this.depthWhole = 10;
    this.categoryName = 'Partition';

    this.boxService.getSubcategory(this.subcategoryCode)
    .then((subcategory: Subcategory) => {

      for (const image of subcategory.images) {
        if (image.default) {
          this.mainGalleryImageURL = image.location ?? '';
          break;
        }
      }

      this.selectedSubcategory = subcategory;
      this.selectedBoardStrength = {
        code: 'standard32',
        name: 'Standard 32',
        strength: '32',
        deserialize(input: any): BoardStrength {
          // super.deserialize(input);
          this.code = input.code;
          this.name = input.name;
          this.strength = input.strength;
          return this;
        },
        id: 1,
        createdBy: 'SYSTEM',
        createdTime: new Date(),
        updatedBy: 'SYSTEM',
        updatedTime: new Date()

      };
      this.paperTypes = this.boxService.getPaperTypes(this.selectedSubcategory);
      this.paperType = this.paperTypes[1];
      this.quantity = 10;
      this.presets = [];
      this.selectedPreset = undefined;
      this.prices = [];
      this.allowCustomSizes = subcategory.allowCustomSizes ?? false;
      this.displayPremiumWhite = subcategory.displayPremiumWhite ?? false;
      this.displayWhite = subcategory.displayWhite ?? false;
      this.displayKraft = subcategory.displayKraft ?? false;
      this.displaySecondaryWhite = subcategory.displaySecondaryWhite ?? false;
      this.displaySecondaryKraft = subcategory.displaySecondaryKraft ?? false;
      this.displayTwoSided = subcategory.displayTwoSided ?? false;
      this.displayLuxe = subcategory.displayLuxe ?? false;
      this.displayStandard = subcategory.displayStandard ?? false;
      this.allowCustomSample = subcategory.allowCustomSample ?? false;
      this.hasVariants = subcategory.hasVariants ?? false;


      this.updatePrintingOptions();
      this.updateMaterialOptions();
      this.listPartitionPrices();

    }, (reason: any) => {
      this.showModal(this.notFoundModal);
      this.logger.error(reason);
    });
  }

  getTissue() {

    this.categoryName = 'Tissue';

    this.boxService.listPresets(this.categoryCode, this.subcategoryCode)
    .then((presets: any[]) => {

      this.boxService.getSubcategory(this.subcategoryCode)
      .then((subcategory: Subcategory) => {
        this.pageLoaded = true;
        this.presets = presets;
        for (const image of subcategory.images) {
          if (image.default) {
            this.mainGalleryImageURL = image.location ?? '';
            break;
          }
        }
        this.selectedPreset = presets[0];
        this.selectedSubcategory = subcategory;
        this.paperTypes = this.boxService.getPaperTypes(this.selectedSubcategory);
        this.paperType = this.paperTypes[0];
        this.quantity = 10;
        this.prices = [];
        this.allowCustomSizes = subcategory.allowCustomSizes ?? false;
        this.displayPremiumWhite = subcategory.displayPremiumWhite ?? false;
        this.displayWhite = subcategory.displayWhite ?? false;
        this.displayKraft = subcategory.displayKraft ?? false;
        this.displaySecondaryWhite = subcategory.displaySecondaryWhite ?? false;
        this.displaySecondaryKraft = subcategory.displaySecondaryKraft ?? false;
        this.displayTwoSided = subcategory.displayTwoSided ?? false;
        this.displayLuxe = subcategory.displayLuxe ?? false;
        this.displayStandard = subcategory.displayStandard ?? false;
        this.allowCustomSample = subcategory.allowCustomSample ?? false;
        this.hasVariants = subcategory.hasVariants??false;

        this.updatePrintingOptions();
        this.updateMaterialOptions();
        this.listTissuePrices();

      }, (reason: any) => {
        this.showModal(this.notFoundModal);
        this.logger.error(reason);
      });
    });
  }

  getCrinkle() {

    this.categoryName = 'Crinkle';

    this.boxService.listPresets(this.categoryCode, this.subcategoryCode)
    .then((presets: any[]) => {

      this.boxService.getSubcategory(this.subcategoryCode)
      .then((subcategory: Subcategory) => {
        this.pageLoaded = true;
        this.presets = presets;
        for (const image of subcategory.images) {
          if (image.default) {
            this.mainGalleryImageURL = image.location ?? '';
            break;
          }
        }
        this.selectedPreset = presets[0];
        this.selectedSubcategory = subcategory;
        this.paperTypes = this.boxService.getPaperTypes(this.selectedSubcategory);
        // this.paperType = this.paperTypes[0].id;
        this.quantity = 10;
        this.prices = [];
        this.allowCustomSizes = subcategory.allowCustomSizes ?? false;
        this.displayPremiumWhite = subcategory.displayPremiumWhite ?? false;
        this.displayWhite = subcategory.displayWhite ?? false;
        this.displayKraft = subcategory.displayKraft ?? false;
        this.displaySecondaryWhite = subcategory.displaySecondaryWhite ?? false;
        this.displaySecondaryKraft = subcategory.displaySecondaryKraft ?? false;
        this.displayTwoSided = subcategory.displayTwoSided ?? false;
        this.displayLuxe = subcategory.displayLuxe ?? false;
        this.displayStandard = subcategory.displayStandard ?? false;
        this.allowCustomSample = subcategory.allowCustomSample ?? false;
        this.hasVariants = subcategory.hasVariants??false;
        this.listCrinklePrices();

      }, (reason: any) => {
        this.showModal(this.notFoundModal);
        this.logger.error(reason);
      });
    }, (reason: any) => {
      this.showModal(this.notFoundModal);
      this.logger.error(reason);
    });
  }

  getLabel() {

    this.categoryName = 'Label';

    this.boxService.listPresets(this.categoryCode, this.subcategoryCode)
    .then((presets: any[]) => {
      presets = presets.filter((x: { label: string; }) => {
        return (x.label.toLowerCase().includes(this.shape.toLowerCase()));
      });

      presets.forEach((x: { label: string; }) => {
        const i = x.label.indexOf('(');
        x.label = x.label.substr(0, i);
      });

      this.boxService.getSubcategory(this.subcategoryCode)
      .then((subcategory: Subcategory) => {
        this.pageLoaded = true;
        for (const image of subcategory.images) {
          if (image.default) {
            this.mainGalleryImageURL = image.location??'';
            break;
          }
        }
        this.presets = presets;
        this.selectedPreset = presets[0];
        this.length = this.selectedPreset?.length??0;
        this.width = this.selectedPreset?.width??0;
        this.depth = this.selectedPreset?.depth??0;
        this.selectedSubcategory = subcategory;
        this.paperTypes = this.boxService.getPaperTypes(this.selectedSubcategory);
        this.paperType = this.paperTypes[0];
        this.prices = [];
        this.allowCustomSizes = subcategory.allowCustomSizes??false;
        this.displayPremiumWhite = subcategory.displayPremiumWhite ?? false;
        this.displayWhite = subcategory.displayWhite ?? false;
        this.displayKraft = subcategory.displayKraft ?? false;
        this.displaySecondaryWhite = subcategory.displaySecondaryWhite ?? false;
        this.displaySecondaryKraft = subcategory.displaySecondaryKraft ?? false;
        this.displayTwoSided = subcategory.displayTwoSided ?? false;
        this.displayLuxe = subcategory.displayLuxe ?? false;
        this.displayStandard = subcategory.displayStandard ?? false;
        this.allowCustomSample = subcategory.allowCustomSample ?? false;
        this.hasVariants = subcategory.hasVariants??false;
        this.quantity = 10;

        this.updatePrintingOptions();
        this.updateMaterialOptions();
        this.listLabelPrices();

      }, (reason: any) => {
        this.showModal(this.notFoundModal);
        this.logger.error(reason);
      });
    }, (reason: any) => {
      this.showModal(this.notFoundModal);
      this.logger.error(reason);
    });
  }

  getVariants() {
    if (this.subcategoryCode === 'SNAP2S' || this.subcategoryCode === 'SNAP2RS') {
      this.luxe = true;
      this.options = 'superseal';
    }
    if (!this.selectedVariant) {
      this.boxService.getVariants(this.selectedSubcategory!.id??0)
      .then((value: any[]) => {
        this.variants = value;
        this.selectedVariant = this.variants[0];
      }, (reason: any) => {
        this.showModal(this.notFoundModal);
        this.logger.error(reason);
      });
    } else {
      this.selectedPreset = undefined;
    }
  }

  updateForm() {
    if (this.isLabel) {
      this.updateLabelForm();
    } else if (this.isOtherProduct) {
      this.updateOtherProductForm();
    } else {
      this.box = undefined;
      if (this.subcategoryCode === 'DHC') {
        this.categoryName = 'Display Header Card';
        this.customSizeEntered = true;
      } else {
        this.categoryName = this.selectedPreset?.type?.name + ' ' + this.selectedBoardType?.name;
      }

      if (!this.customSizeEntered) {
        this.length = this.selectedPreset?.length??0;
        this.lengthWhole = this.getWholeNumber(this.length);
        this.lengthFraction = this.convertFractionToDecimal(this.length);
        this.width = this.selectedPreset?.width??0;
        this.widthWhole = this.getWholeNumber(this.width);
        this.widthFraction = this.convertFractionToDecimal(this.width);
        this.depth = this.selectedPreset?.depth??0;
        this.depthWhole = this.getWholeNumber(this.depth);
        this.depthFraction = this.convertFractionToDecimal(this.depth);
      } else {
        this.length = this.lengthWhole + this.convertFractionToDecimal(this.lengthFraction);
        this.width = this.widthWhole + this.convertFractionToDecimal(this.widthFraction);
        this.depth = this.depthWhole + this.convertFractionToDecimal(this.depthFraction);
      }

      this.boardStrengthList = this.selectedBoardType?.boardStrengths??[];
      this.selectedBoardStrength = this.boardStrengthList.find(value => value.code === this.selectedBoardStrength?.code);
      if (!this.selectedBoardStrength) {
        this.selectedBoardStrength = this.boardStrengthList[0];
      }
      this.noPrinting = false;
      this.updatePrintingOptions();
      this.updateMaterialOptions();
      if (this.customQuantityActive) {
        this.enteredCustomQuantity = Number(this.quantity.toString().split('(')[0]);
        this.paperTypeId = this.resolvePaperTypeId();
        this.gloss = this.finish === 'Gloss';
        this.checkForViolations();
      }
      // if (!this.customQuantityActive) {
      if (this.isPizza) {
        this.listPizzaPrices();
      } else if (this.isPaddedMailer) {
        this.listPaddedMailerPrices();
      } else {
        this.listPrices();
      }
    }
  }

  updateLabelForm() {
    this.box = undefined;
    this.prices = [];

    this.length = this.selectedPreset?.length??0;
    this.lengthWhole = this.getWholeNumber(this.length);
    this.lengthFraction = this.convertFractionToDecimal(this.length);
    this.width = this.selectedPreset?.width??0;
    this.widthWhole = this.getWholeNumber(this.width);
    this.widthFraction = this.convertFractionToDecimal(this.width);
    this.depth = this.selectedPreset?.depth??0;
    this.depthWhole = this.getWholeNumber(this.depth);
    this.depthFraction = this.convertFractionToDecimal(this.depth);

    this.expedited = false;
    this.noPrinting = false;
    this.updatePrintingOptions();
    this.updateMaterialOptions();
    // if (this.isValid) {
    this.listLabelPrices();
  }

  updateOtherProductForm() {
    this.box = undefined;
    this.prices = [];

    console.log('Length slots is: ', this.lengthSlots);

    if (!this.customSizeEntered) {
      this.length = this.selectedPreset?.length??0;
      this.lengthWhole = this.getWholeNumber(this.length);
      this.lengthFraction = this.convertFractionToDecimal(this.length);
      this.width = this.selectedPreset?.width??0;
      this.widthWhole = this.getWholeNumber(this.width);
      this.widthFraction = this.convertFractionToDecimal(this.width);
      this.depth = this.selectedPreset?.depth??0;
      this.depthWhole = this.getWholeNumber(this.depth);
      this.depthFraction = this.convertFractionToDecimal(this.depth);
    } else {
      this.length = this.getWholeNumber(this.length) + this.convertFractionToDecimal(this.lengthFraction);
      this.width = this.widthWhole + this.convertFractionToDecimal(this.widthFraction);
      this.depth = this.depthWhole + this.convertFractionToDecimal(this.depthFraction);
    }
    this.expedited = false;
    this.noPrinting = false;
    this.updatePrintingOptions();
    this.updateMaterialOptions();

    if (this.isTape) {
      this.listTapePrices();
    } else if (this.isTissue) {
      this.listTissuePrices();
    } else if (this.isCrinkle) {
      this.listCrinklePrices();
    } else {
      this.listPartitionPrices();
    }
  }

  // Called from the custom size container. Takes the length entered and fraction selected
  // And creates a respective length, width, and depth and then calls pricing function.
  checkForPresets() {
    this.length = this.lengthWhole + this.convertFractionToDecimal(this.lengthFraction);
    this.width = this.widthWhole + this.convertFractionToDecimal(this.widthFraction);
    if (!this.isDHC) {
      this.depth = this.depthWhole + this.convertFractionToDecimal(this.depthFraction);
    } else {
      this.depth = this.convertFractionToDecimal(this.depthFraction);
    }
    if (this.selectedPrice) {
      this.quantity = (this.selectedPrice?.quantity??1) ;
    } else {
      if (this.standard) {
        this.quantity = 100;
      } else {
        this.quantity = 1000;
      }
    }
    if (this.subcategoryCode === 'part') {
      this.listPartitionPrices();
    } else if (this.subcategoryCode === 'tissue') {
      this.listTissuePrices();
    } else if (this.subcategoryCode === 'tape') {
      this.listTapePrices();
    } else if (this.isLabel) {
      this.listLabelPrices();
    } else {
      this.listPrices();
    }
  }

  presetSuggestionSelected(preset: { id: any; }) {
    // After user selects the suggest preset instead of custom sizing,
    // find the preset's ID in the existing presetsList and set that as the selectedPreset.
    this.presets.forEach((item, index) => {
      if (preset.id === this.presets[index].id) {
        this.selectedPreset = this.presets[index];
      }
    });
    this.customSizeEntered = false;
    this.updateForm();
  }

  checkForViolations() {
    if (this.enteredCustomQuantity) {
      this.quantity = this.enteredCustomQuantity as number;
    } else {
      this.enteredCustomQuantity = this.quantity;
    }

    let paperTypeName = 'white';
    if (this.outerMaterial === 'Kraft' || this.outerMaterial === 'k') {
      paperTypeName = 'kraft';
    }

    if (this.isPaddedMailer) {
      this.boxService.getPaddedMailerPrice(this.selectedPreset!.type!.code!, paperTypeName, this.quantity)
      .then((value: any) => {

        // If custom quantity is 1 then it is considered a sample and is allowed

        this.customQuantityViolation = (this.enteredCustomQuantity??0) !== 1
          && ((this.enteredCustomQuantity as number??0) < this.prices[0].minimumOrder || (this.enteredCustomQuantity as number??0) > this.prices[0].maxQuantity);

        if (!this.customQuantityViolation) {
          this.selectedPrice = value.price;
          this.enteredCustomQuantity +=
            ` cases of ${this.selectedPrice?.unitsPerCase} ($${this.selectedPrice?.pricePerUnit?.toFixed(2)}) each`;
        }
      })
      .catch(() => {
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    } else if (this.isPartition) {
      this.boxService.getPartitionPrice('e', this.depth, this.length, this.cellLength, paperTypeName,
        this.quantity, this.width, this.cellWidth, this.lengthSlots, this.widthSlots)
      .then((value: any) => {

          // If custom quantity is 1 then it is considered a sample and is allowed

          this.customQuantityViolation =  this.enteredCustomQuantity !== 1
          && (this.enteredCustomQuantity as number < this.prices[0].minimumOrder || this.enteredCustomQuantity as number > this.prices[0].maxQuantity);

          if (!this.customQuantityViolation) {
            this.selectedPrice = value.price;
            this.enteredCustomQuantity += ` ($${this.selectedPrice?.pricePerUnit?.toFixed(2)}) each`;
          }
      }).catch(() => {
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    } else if (this.isTape) {

      this.boxService.getTapePrice(paperTypeName, this.quantity)
      .then((value: any) => {

        this.customQuantityViolation =  this.enteredCustomQuantity !== 1
        && (this.enteredCustomQuantity as number < this.prices[0].minimumOrder || this.enteredCustomQuantity as number > this.prices[0].maxQuantity);

        if (!this.customQuantityViolation) {
          this.selectedPrice = value.price;
          // 8 rolls per case
          this.enteredCustomQuantity += ` case(s) ($${value.price.pricePerCase.toFixed(2) / 8}/Roll)`;
        }
      }).catch(() => {
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    } else if (this.isTissue) {
      if (this.quantity % 100 !== 0) {
        this.tissueIncrementViolation = true;
      } else {
        this.tissueIncrementViolation = false;
        this.boxService.getTissuePrice(Math.ceil(this.quantity / 100), 18)
        .then((value: any) => {

          this.customQuantityViolation = (this.enteredCustomQuantity as number < this.prices[0].minimumOrder
            || this.enteredCustomQuantity as number > this.prices[0].maxQuantity) && this.enteredCustomQuantity as number !== 1;

          if (!this.customQuantityViolation) {
            this.selectedPrice = value.price;
            this.enteredCustomQuantity += ` sheets ($${value.price.pricePerSheet.toFixed(2)} per sheet)`;
          }
        })
        .catch(() => {
          this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
        });
      }
    } else if (this.isLabel) {
      this.boxService.getLabelPrice(this.quantity, this.shape.toLowerCase(), 'c', this.length, this.width, this.depth)
        .then((value: any) => {

          this.customQuantityViolation = (this.enteredCustomQuantity as number < this.prices[0].minimumOrder
            || this.enteredCustomQuantity as number > this.prices[0].maxQuantity) && this.enteredCustomQuantity !== 1;

          if (!this.customQuantityViolation) {
            this.selectedPrice = value.price;
            this.enteredCustomQuantity += ` ($${value.price.pricePerUnit.toFixed(2)}) each`;
          }
        })
      .catch(() => {
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    } else if (this.isCrinkle) {
      const enteredQuantity = parseInt(this.enteredCustomQuantity as any);
      if (Number.isNaN(enteredQuantity)) {
        return;
      }
      const color = this.normalizeCrinkleColor(this.selectedPreset?.label ?? '');
      this.boxService.getCrinklePrice(enteredQuantity, color)
      .then((value: any) => {

        this.customQuantityViolation = (enteredQuantity < this.prices[0].minimumOrder
          || enteredQuantity > this.prices[0].maxQuantity) && enteredQuantity !== 1;

        if (!this.customQuantityViolation) {
          this.selectedPrice = value.price;
          this.enteredCustomQuantity = `${enteredQuantity} ($${value.price.pricePerUnit.toFixed(2)}) each` as any;
        }
      })
      .catch(() => {
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    } else {

      this.boxService.getPrice(this.boxCode!, this.selectedBoardStrength?.strength!, this.paperTypeId, this.length,
        this.width, this.depth, this.quantity, this.twoSided, this.luxe, this.gloss, this.noPrinting,'',
        (this.expedited !== undefined ? this.expedited : false))
        .then((value: any) => {
          this.box = value;
          if (!this.luxe) {
            this.customQuantityViolation =
              (this.enteredCustomQuantity  as number < (this.box?.boxType?.minimumOrder??1) || this.enteredCustomQuantity  as number > (this.box?.boxType?.maxQuantity??0))
              && (this.enteredCustomQuantity !== '1' || this.subcategoryCode === 'SNAP2' || this.subcategoryCode === 'SNAP2R');
          } else {
            this.customQuantityViolation =
              (this.enteredCustomQuantity  as number < (this.box?.boxType?.luxeMinimumOrder??1) || this.enteredCustomQuantity  as number > (this.box?.boxType?.maxQuantity??0))
              && (this.enteredCustomQuantity !== '1' || this.subcategoryCode === 'SNAP2' || this.subcategoryCode === 'SNAP2R');
          }
          if (this.subcategoryCode === 'PIZ' && this.enteredCustomQuantity === '1') {
            this.customQuantityViolation = true;
          }

          if (!this.customQuantityViolation) {
            this.selectedPrice = value.price;
            this.enteredCustomQuantity += ` ($${this.selectedPrice?.pricePerUnit?.toFixed(2)}) each`;
          }
        })
      .catch(() => {
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    }
  }
  numberOnly(event: { which: any; keyCode: any; }) {
    const charCode = (event.which) ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }


  listPrices() {
    this.prices = [];
    this.updating = true;
    this.paperTypeId = this.resolvePaperTypeId();

    this.gloss = this.finish === 'Gloss';

    this.quantities = [];
    if (this.standard) {
      this.quantities = [...this.standardQuantities];
    } else if (this.noprint) {
      if (this.subcategoryCode === 'SNAP2' && this.printing === 'Blank Boxes | No Printing') {
        this.luxe = true;
        this.noprint = true;
        this.quantities.push();
      }

      this.quantities = [...this.standardQuantities];
    } else if (this.noprint) {
      if (this.subcategoryCode === 'SNAP2R' && this.printing === 'Blank Boxes | No Printing') {
        this.luxe = true;
        this.noprint = true;
        this.quantities.push();
      }

      this.quantities = [...this.standardQuantities];
    } else if (this.luxe) {
      if (this.subcategoryCode === 'SNAP2') {
        this.quantities.push();
      }
      this.luxeQuantities.forEach(quantity => {
        this.quantities.push(quantity);
      });
    } else if (this.luxe) {
      if (this.subcategoryCode === 'SNAP2R') {
        this.quantities.push();
      }
      this.luxeQuantities.forEach(quantity => {
        this.quantities.push(quantity);
      });
    }

    if ((this.printing.includes('Luxe') || this.printing === 'Blank Boxes | No Printing') && this.subcategoryCode === 'SNAP2') {
      this.luxe = true;
      this.options = '';
    } else if ((this.printing.includes('Luxe') || this.printing === 'Blank Boxes | No Printing') && this.subcategoryCode === 'SNAP2S') {
      this.luxe = true;
    }
    if ((this.printing.includes('Luxe') || this.printing === 'Blank Boxes | No Printing') && this.subcategoryCode === 'SNAP2R') {
      this.luxe = true;
      this.options = '';
    } else if ((this.printing.includes('Luxe') || this.printing === 'Blank Boxes | No Printing') && this.subcategoryCode === 'SNAP2RS') {
      this.luxe = true;
    }
    this.boxService.listPrices(this.boxCode!, this.selectedBoardStrength?.strength!, this.paperTypeId, this.length, this.width, this.depth,
      this.quantities, this.twoSided, this.luxe, this.noPrinting, '', this.expedited)
      .then((priceData: any) => {
        if (priceData.prices.length > 0 && !this.customQuantityActive) {
          if (!this.quantityArrayIndex) {
            if (this.standard) {
              this.selectedPrice = priceData.prices[4];
            } else if (this.noprint) {
              this.selectedPrice = priceData.prices[4];
            } else {
              this.selectedPrice = priceData.prices[0];
            }
            // Default SNAP2 quantity to 1000
            if (this.subcategoryCode.startsWith('SNAP2')) {
              this.selectedPrice = priceData.prices[0];
            }
          } else {
            this.selectedPrice = priceData.prices[this.quantityArrayIndex];
          }
        }
        this.box = priceData.box;
        if (this.box?.boxType?.code === 'RSCB') {
          if ((this.box.dimensions?.length??0) > 2.9375 && (this.box.dimensions?.width??0) > 2.9375 && (this.box.dimensions?.depth??0) > 2.9375) {
            priceData.box.violations = priceData.box.violations.filter((x: { rule: string | string[]; }) => !x.rule.includes('Rule15'));
          } else {
            priceData.box.violations.map((x: { rule: string | string[]; message: string; }) => {
              if (x.rule.includes('Rule15')) {
                x.message = 'Please call to order';
              }
              return x;
            });
          }
          //
        }
        this.violations = priceData.box.violations;
        if (!this.luxe) {
          priceData.prices = priceData.prices.filter((x: { quantity: number; }) => ((x.quantity >= priceData.prices[0].minimumOrder)
            && (x.quantity <= priceData.prices[0].maxQuantity)) || (this.selectedSubcategory?.allowCustomSample && x.quantity === 1));
        } else {
          priceData.prices = priceData.prices.filter((x: { quantity: number; }) => (x.quantity >= priceData.prices[0].luxeMinimumOrder)
            || (this.selectedSubcategory?.allowCustomSample && x.quantity === 1));
        }

        if (this.selectedSubcategory?.allowCustomSample) {
          priceData.prices.push();
        }
        this.prices = priceData.prices;
        console.log('The prices are: ', this.prices);
        this.presetMatches = priceData.presetMatches??[];
        this.customSizeIncrease = priceData.customSizeIncrease / 100;
        // this.boardTypeList = priceData.box.boxType.subcategory.boardTypes;
        const something = priceData.box.violations.find((violation: { warning: any; error: any; }) => {
          if (this.subcategoryCode === 'OPF') {
            return !violation.warning;
          }
          return violation.error;
        });

        this.hasViolationErrors = something !== undefined;
        this.updating = false;
      }, (reason: any) => {
        this.showModal(this.notFoundModal);
        this.logger.error(reason);
        this.prices = [];
        this.updating = false;
      });
  }

  public trackByFn(index: any, item: { id: any; }) {
    if (!item) {
      return null;
    } else {
      return item.id;
    }
  }

  listPizzaPrices() {

    this.quantities = [500, 750, 1000, 1250, 1500, 1750, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000];
    this.luxe = true;
    this.prices = [];
    this.updating = true;
    if (this.getPaperTypeID(this.outerMaterial) === 'pkw' || this.getPaperTypeID(this.innerMaterial) === 'pkw') {
      this.paperTypeId = 'pkw';
    } else if (this.categoryCode === 'Event Boxes') {
      this.paperTypeId = this.getPaperTypeID(this.outerMaterial);
    } else if (this.getPaperTypeID(this.outerMaterial) === 'k') {
      this.paperTypeId = 'k';
    } else {
      this.paperTypeId = 'kw';
    }

    this.gloss = this.finish === 'Gloss';

    this.boxService.listPrices(this.boxCode!, this.selectedBoardStrength?.strength!,
      this.paperTypeId, this.length, this.width, this.depth, this.quantities, this.twoSided,
      this.luxe, this.noPrinting, '', this.expedited)
      .then((priceData:any) => {
        if (priceData.prices.length > 0) {
          if (!this.quantityArrayIndex) {
            if (this.standard) {
              this.selectedPrice = priceData.prices[4];
            } else {
              this.selectedPrice = priceData.prices[0];
            }
            // Default SNAP2 quantity to 1000
            if (this.subcategoryCode === 'SNAP2') {
              this.selectedPrice = priceData.prices[0];
            }
            if (this.subcategoryCode === 'SNAP2S') {
              this.selectedPrice = priceData.prices[0];
            }
            if (this.subcategoryCode === 'SNAP2R') {
              this.selectedPrice = priceData.prices[0];
            }
            if (this.subcategoryCode === 'SNAP2RS') {
              this.selectedPrice = priceData.prices[0];
            }
          } else {
            this.selectedPrice = priceData.prices[this.quantityArrayIndex];
          }
        }
        this.box = priceData.box;
        this.violations = priceData.box.violations;
        if (!this.luxe) {
          priceData.prices = priceData.prices.filter((x: { quantity: number; }) => ((x.quantity >= priceData.prices[0].minimumOrder)
            && (x.quantity <= priceData.prices[0].maxQuantity)) || (this.selectedSubcategory?.allowCustomSample && x.quantity === 1));
        } else {
          priceData.prices = priceData.prices.filter((x: { quantity: number; }) => (x.quantity >= priceData.prices[0].luxeMinimumOrder)
            || (this.selectedSubcategory?.allowCustomSample && x.quantity === 1));
        }

        if (this.selectedSubcategory?.allowCustomSample) {
          priceData.prices.push();
        }
        this.prices = priceData.prices;
        console.log('The prices are: ', this.prices);
        this.presetMatches = priceData.presetMatches??[];
        this.customSizeIncrease = priceData.customSizeIncrease / 100;
        // this.boardTypeList = priceData.box.boxType.subcategory.boardTypes;
        const something = priceData.box.violations.find((violation: { warning: any; }) => {
          return !violation.warning;
        });

        this.hasViolationErrors = something !== undefined;
        this.updating = false;
      }, (reason: any) => {
        this.showModal(this.notFoundModal);
        this.logger.error(reason);
        this.prices = [];
        this.updating = false;
      });
  }


  listPaddedMailerPrices() {
    switch (this.selectedPreset?.type?.code??'') {
      case 'RPM00Z':
        this.quantities = [1, 2, 10, 20, 100];
        break;
      case 'RPM02Z':
      case 'RPM05Z':
        this.quantities = [1, 5, 20, 50, 100, 200];
        break;
      case 'RPM06Z':
        this.quantities = [1, 10, 50, 150, 250, 500];
        break;
    }

    if (this.getPaperTypeID(this.material) === 'kw') {
      this.paperTypeId = 'w';
    }
    this.noPrinting = this.printing === 'Blank Mailers | No Printing';

    const paperType = this.outerMaterial === 'Kraft' || this.outerMaterial === 'k' ? 'kraft' : 'white';
    this.boxService.listPaddedMailerPrices(this.selectedPreset?.type?.code??'', paperType, this.quantities)
    .then((priceData: any) => {
      this.pageLoaded = true;

      if (priceData.prices.length > 0 && !this.customQuantityActive) {
        this.selectedPrice = priceData.prices[0];
      }
      this.prices = priceData.prices;
      this.presetMatches = priceData.presetMatches??[];
      this.customSizeIncrease = priceData.customSizeIncrease;
      // this.boardTypeList = priceData.box.boxType.subcategory.boardTypes;
      if (!this.boardType) {
        this.boardType = this.boardTypeList[0];
      }

      this.updating = false;
    })
    .catch(() => {
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }


  listTapePrices() {
    this.quantities = [3, 10, 20, 50, 100];

    let paperTypeName = 'white';
    if (this.material === 'Kraft') {
      paperTypeName = 'kraft';
    }
    if (this.getPaperTypeID(this.material) === 'kw') {
      this.paperTypeId = 'w';
    }

    this.boxService.listTapePrices(paperTypeName, this.quantities)
    .then((priceData: any) => {
      this.pageLoaded = true;

      priceData.prices = priceData.prices.filter((price: any) => price);
      this.selectedPrice = priceData.prices[0];
      this.prices = priceData.prices;
      this.presetMatches = priceData.presetMatches??[];
      this.customSizeIncrease = priceData.customSizeIncrease / 100;
      // this.boardTypeList = priceData.box.boxType.subcategory.boardTypes;
      if (!this.boardType) {
        this.boardType = this.boardTypeList[0];
      }

      this.updating = false;
    })
    .catch(() => {
      this.updating = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }


  listPartitionPrices() {
    this.quantities = [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1500, 2000, 5000, 10000, 12000];

    let paperTypeName = 'white';
    if (this.material === 'Kraft') {
      paperTypeName = 'kraft';
    }

    this.boxService.listPartitionPrices('e', this.depth, this.length, this.cellLength, paperTypeName,
      this.quantities, this.width, this.cellWidth, this.lengthSlots, this.widthSlots)
    .then((priceData: any) => {
        priceData.prices = priceData.prices.filter((x: { pricePerUnit: any; }) => x.pricePerUnit);
        this.pageLoaded = true;
        if (priceData.prices.length > 0) {
          if (this.standard) {
            this.selectedPrice = priceData.prices[4];
          } else {
            this.selectedPrice = priceData.prices[0];
          }
        }

        this.prices = priceData.prices;
        this.presetMatches = priceData.presetMatches??[];
        this.customSizeIncrease = priceData.customSizeIncrease / 100;

        this.violations = priceData.partition.constraintViolations;

        const something = priceData.partition.constraintViolations.find((violation: { warning: any; }) => {
          return !violation.warning;
        });

        this.hasViolationErrors = something !== undefined;

        this.updating = false;
    })
    .catch(() => {
      this.updating = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }

  listTissuePrices() {
    this.quantities = [2, 3, 4, 5, 6, 7, 8];

    // Weight is always 18
    this.boxService.listTissuePrices(this.quantities, 18)
    .then((priceData: any) => {
      this.pageLoaded = true;

      priceData.prices = priceData.prices.filter((price: null) => {
        return price != null;
      });

      // To display # of sheets, multiple quantity by 100 because 100 sheets per ream
      priceData.prices.forEach((price: { totalSheets: number; quantity: number; minimumOrder: number; maxQuantity: number; }) => {
        price.totalSheets = price.quantity * 100;
        price.minimumOrder *= 100;
        price.maxQuantity *= 100;
        price.quantity *= 100;
      });

      this.selectedPrice = priceData.prices[0];
      this.prices = priceData.prices;
      this.presetMatches = priceData.presetMatches??[];
      this.customSizeIncrease = priceData.customSizeIncrease / 100;

      this.updating = false;
    })
    .catch(() => {
      this.updating = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }

  listCrinklePrices() {
    this.quantities = [1, 5, 10];
    const color = this.normalizeCrinkleColor(this.selectedPreset?.label ?? '');
    this.boxService.listCrinklePrices(this.quantities, color)
    .then((priceData: any) => {
      this.pageLoaded = true;

      priceData.prices = priceData.prices.filter((price: null) => {
        return price != null;
      });
      this.customQuantityActive = false;
      this.selectedPrice = priceData.prices[0];
      this.prices = priceData.prices;
      this.presetMatches = priceData.presetMatches??[];
      this.customSizeIncrease = priceData.customSizeIncrease / 1;

      this.updating = false;
    })
    .catch(() => {
      this.updating = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }


  listLabelPrices() {
    this.quantities = [100, 200, 250, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000,
      5500, 6000, 6500, 7000, 7500, 8000, 8500, 9000, 9500, 10000];

    this.boxService.listLabelPrices(this.quantities, this.shape.toLowerCase(), 'c', this.length, this.width, this.depth)
    .then((priceData: any) => {
      this.pageLoaded = true;

      priceData.prices = priceData.prices.filter((price: null) => {
        return price != null;
      });

      this.selectedPrice = priceData.prices[0];
      this.prices = priceData.prices;
      this.presetMatches = priceData.presetMatches??[];
      this.customSizeIncrease = priceData.customSizeIncrease / 100;

      this.updating = false;
    })
    .catch(() => {
      this.updating = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }

  getPaperTypeID(paperType: string) {
    if (paperType === 'Kraft') {
      return 'k';
    } else if (paperType === 'Premium White') {
      return 'pkw';
    } else {
      return 'kw';
    }
  }

  // Event Boxes price off the outer material alone (unless premium white is involved); every other
  // category collapses outer + inner via the shared pricing rule.
  private resolvePaperTypeId(): string {
    const outer = this.getPaperTypeID(this.outerMaterial);
    const inner = this.getPaperTypeID(this.innerMaterial);
    if (outer !== 'pkw' && inner !== 'pkw' && this.categoryCode === 'Event Boxes') {
      return outer;
    }
    return getPricingPaperType(outer, inner);
  }

  get boxCode() {
    let code = this.selectedSubcategory?.code;

    if (this.selectedBoardType) {
      code += this.selectedBoardType?.flute??"";
    }
    if (this.selectedPreset && !this.selectedSubcategory?.allowCustomSizes && this.subcategoryCode !== 'tissue') {
      code = this.selectedPreset?.type?.code;
    }

    if (this.subcategoryCode === 'tape') {
      code = 'tape';
    }
    return code;
  }

  get luxePrinting() {
    return this.selectedPrintType && this.selectedPrintType.id === 'luxe';
  }
  updatePrintingOptions() {

    this.printingOptions = [];

    if (this.displayStandard) {
      this.printingOptions.push('Standard | Outside');
      if (this.displayTwoSided) {
        this.printingOptions.push('Standard | Inside', 'Standard | 2-Sided');
      }
    }
    if (this.displayLuxe) {
      this.printingOptions.push('Luxe | Outside');
      if (this.displayTwoSided) {
        this.printingOptions.push('Luxe | Inside', 'Luxe | 2-Sided');
      }
    }
    if (this.displayNoprint) {
      if (this.isPaddedMailer) {
        this.printingOptions.push('Blank Mailers | No Printing');
      } else {
        this.printingOptions.push('Blank Boxes | No Printing');
      }
    }
    // If printing not selected yet, default to first option.
    if (!this.printing && this.printingOptions.length > 0) {
      this.printing = this.isTest ? this.productDetails.print : this.printingOptions[0];
      this.printingSelected(this.printing);
    }

    console.log('printingOptions', this.printingOptions);
  }

  printingSelected(printingType: any) {
    this.printing = printingType;

    if (this.printing === 'Standard | Outside') {
      // If changing from Luxe -> Standard, reset quantity to default.
      this.insideOnly = false;
      if (this.luxe) {
        this.quantityArrayIndex = 2;
      }
      this.standard = true;
      this.luxe = false; this.twoSided = false; this.insideOnly = false;
    } else if (this.printing === 'Standard | Inside') {
      this.insideOnly = true;
      // If changing from Luxe -> Standard, reset quantity to default.
      if (this.luxe) {
        this.quantityArrayIndex = 2;
      }
      this.standard = true;
      this.luxe = false; this.twoSided = false; this.insideOnly = true;
    } else if (this.printing === 'Blank Boxes | No Printing') {
      this.insideOnly = false;
      this.standard = false;
      this.noprint = true;
      this.luxe = false; this.twoSided = false; this.insideOnly = false;
    } else if (this.printing === 'Standard | 2-Sided') {
      this.insideOnly = false;
      // If changing from Luxe -> Standard, reset quantity to default.
      if (this.luxe) {
        this.quantityArrayIndex = 2;
      }
      this.standard = true; this.twoSided = true; this.insideOnly = false;
      this.luxe = false;
    } else if (this.printing === 'Luxe | Outside') {
      this.insideOnly = false;
      // If changing from Standard -> Luxe, reset quantity to default.
      if (this.standard) {
        this.quantityArrayIndex = 0;
      }
      this.luxe = true;
      this.noprint = false;
      this.standard = false; this.twoSided = false; this.insideOnly = false;
    } else if (this.printing === 'Luxe | Inside') {
      this.insideOnly = true;
      // If changing from Standard -> Luxe, reset quantity to default.
      if (this.standard) {
        this.quantityArrayIndex = 0;
      }
      this.luxe = true;
      this.noprint = false;
      this.standard = false; this.twoSided = false; this.insideOnly = true;
    } else if (this.printing === 'Luxe | 2-Sided') {
      this.insideOnly = false;
      // If changing from Luxe -> Standard, reset quantity to default.
      if (this.luxe) {
        this.quantityArrayIndex = 2;
      }
      this.luxe = true; this.twoSided = true; this.insideOnly = false;
      this.standard = false;
    }
    this.updateFinishOptions();
    this.updateForm();
  }

  updateMaterialOptions() {
    // Clear out materialOptions
    this.materialOptions = [];
    this.outerMaterialOptions = [];
    this.innerMaterialOptions = [];

    if (this.displayWhite) {
      this.materialOptions.push('Standard White');
      if (this.isPaddedMailer) {
        this.outerMaterialOptions.push('White');
      } else {
        this.outerMaterialOptions.push('Standard White');
      }
      if (this.categoryCode !== 'Event Boxes' && this.subcategoryCode !== 'PIZ') {
        this.innerMaterialOptions.push('Standard White');
      }
    }

    if (this.displayPremiumWhite) {
      this.materialOptions.push('Premium White');

      // If inner material is premium white, remove this option from outer material
      if (this.innerMaterial !== 'Premium White' && this.subcategoryCode !== 'PIZ') {
        this.outerMaterialOptions.push('Premium White');
      }
      // If outer material is premium white, remove this option from inner material
      if (this.outerMaterial !== 'Premium White' && this.categoryCode !== 'Event Boxes' && this.subcategoryCode !== 'PIZ') {
        this.innerMaterialOptions.push('Premium White');
      }
    }
    if (this.displayKraft) {
      this.materialOptions.push('Kraft');
      this.outerMaterialOptions.push('Kraft');
      this.innerMaterialOptions.push('Kraft');
    }
    if (this.displaySecondaryKraft && this.subcategoryCode === 'PIZ') {
      this.innerMaterialOptions.push('Kraft');

    }
    // If material not selected yet, default to first option.
    if (!this.material && this.materialOptions.length > 0) {
      this.material = this.materialOptions[0];
    }
    // If outer material not selected yet, default to first option.
    if (!this.outerMaterial && this.outerMaterialOptions.length > 0) {
      this.outerMaterial = this.isTest ? this.productDetails.outerMaterial : this.outerMaterialOptions[0];
    }
    // If inner material not selected yet, default to first option.
    if (!this.innerMaterial && this.innerMaterialOptions.length > 0) {
      this.innerMaterial = this.isTest ? this.productDetails.innerMaterial : this.innerMaterialOptions[0];
    }

    this.updateFinishOptions();

  }

  updateFinishOptions() {

    if (this.luxe && this.printing === 'Luxe | Inside' && this.innerMaterial === 'Premium White') {
      this.finish = 'Semi-Gloss';
      this.finishOptions = ['Semi-Gloss'];
    } else if (this.luxe && this.printing === 'Luxe | Outside' && this.outerMaterial === 'Premium White') {
      this.finish = 'Semi-Gloss';
      this.finishOptions = ['Semi-Gloss'];
    } else if (this.luxe && (this.innerMaterial !== 'Premium White' || this.outerMaterial !== 'Premium White')) {
      this.finish = 'Matte';
      this.finishOptions = ['Matte'];
    } else {
      this.finishOptions = ['Matte'];
    }

    // Displays Finish if premium white is selected.

    // Labels should not display gloss finish
    if (this.standard && this.material === 'Premium White' && !this.isLabel) {
      this.finishOptions.push('Gloss');
    } else if (this.standard && (this.innerMaterial === 'Premium White' || this.outerMaterial === 'Premium White')) {
      this.finishOptions.push('Gloss');
    } else if (this.noprint && (this.innerMaterial === 'Premium White' || this.outerMaterial === 'Premium White')) {
      this.finishOptions.push('Gloss');
    }
  }

  // Displays custom size fractions
  convertDecimalToFraction(num: any) {
    return Fractions.convertDecimalToFraction(num);
  }

  getWholeNumber(fraction: number) {
    const temp = String(fraction).split('.', 2);
    return parseFloat(temp[0]);
  }

  convertFractionToDecimal(fraction: number) {
    const temp = String(fraction).split('.', 2);
    return parseFloat('0.' + temp[1]);
  }

  nextSubcategoryImage() {
    this.selectedImage = (this.selectedImage + 1) % (this.selectedSubcategory?.images?.length??0);
    this.mainGalleryImageURL = this.selectedSubcategory?.images[this.selectedImage].location??'';
  }

  prevSubcategoryImage() {
    const numImages = this.selectedSubcategory?.images.length??0;
    this.selectedImage = (this.selectedImage + numImages - 1) % numImages;
    this.mainGalleryImageURL = this.selectedSubcategory?.images[this.selectedImage].location??'';
  }

  selectSubcategoryPreset(preset: Preset) {
    if (this.updating) {
      return;
    }
    if (!this.selectedPreset || this.selectedPreset?.id !== preset.id) {
      this.selectedPreset = preset;
      this.updateForm();
    }
  }

  selectPresetMatch(preset: Preset) {
    this.length = preset.length;
    this.width = preset.width;
    this.depth = preset.depth;
    this.presetMatches = [];
    this.listPrices();
  }

  addCustomQuantity() {
    if (this.quantity) {
      let valid = true;
      this.quantityError = undefined;
      const quantity = +this.quantity;

      if (this.luxePrinting) {
        if (quantity === 1) {
          this.quantityError = 'Minimum order is ' + this.box?.boxType?.luxeMinimumOrder;
          valid = false;
        } else {
          if (quantity < (this.box?.boxType?.luxeMinimumOrder??1)) {
            this.quantityError = 'Minimum order is ' + (this.box?.boxType?.luxeMinimumOrder??1);
            valid = false;
          }
        }
      } else {
        if (quantity === 1) {
          valid = this.box?.boxType?.subcategory?.allowCustomSample??false;
        } else if (quantity < (this.box?.boxType?.minimumOrder??1)) {
          this.quantityError = 'Minimum order is ' + this.box?.boxType?.minimumOrder;
          valid = false;
        }
      }
      if (quantity > (this.box?.boxType?.maxQuantity??0)) {
        this.quantityError = 'Maximum order is ' + this.box?.boxType?.maxQuantity;
        valid = false;
      }
      if (valid) {
        if (quantity > 0) {
          this.listPrices();
        }
      }
    }
  }

  showModal(template: TemplateRef<any>, templateClass?: string) {
    if (templateClass) {
      this.modal = this.bsModalService.show(template, { class: templateClass });

    } else {
      this.modal = this.bsModalService.show(template, { class: 'modal-lg' });
    }
  }

  hide() {
    this.modal?.hide();
  }

  // If product is tissue, multiply be 100 to get the # of sheets instead of reams
  stripText() {
    if (this.isTissue && (this.selectedPrice?.quantity??1)  < 100) {
      this.enteredCustomQuantity = (this.selectedPrice?.quantity??1)  * 100;
    } else {
      this.enteredCustomQuantity = (this.selectedPrice?.quantity??1) ;
    }
  }

  goToUploadDesign(resolveObj: any) {
    const uploadDetails = {
      Origin: 'designer',
      Category: this.categoryCode,
      Subcategory: resolveObj.boxType.aeCode,
      Code: this.isLabel ? 'label' : resolveObj.boxType.code,
      BoardStrength: this.isOtherProduct ? '32' : resolveObj.boardStrength.strength,
      ContainerId: resolveObj.containerName,
      kraftType: this.getPaperTypeID(this.outerMaterial),
      secondaryKraftType: this.getPaperTypeID(this.innerMaterial),
      paperType: resolveObj.paperTypeId,
      boxDimensions: resolveObj.dimensions,
      // sample: $stateParams.sample,
      gloss: this.gloss,
      shape: this.shape,
      preset: this.selectedPreset !== undefined,
      luxe: this.luxe,
      options: this.options,
      material: this.material,
      rush: this.expedited,
      twoSided: this.twoSided,
      insideOnly: this.insideOnly,
      quantity: (this.selectedPrice?.quantity??1) ,
    };

    this.templateLoading = false;
    this.router.navigate(['upload-design', uploadDetails]);
  }

  createAndDownloadTemplate() {
    this.quantity = (this.selectedPrice?.quantity??1) ;
    this.downloadingTemplate = true;

    this.getTemplate(true)
    .then(template => {
      this.downloadingTemplate = false;

      this.templateDownloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.environment.apiHost}/project/container/${template.container}/${template.templateZip}?download=true&downloadAs=${template.templateZipName}`);
    })
    .catch(() => {
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      this.templateLoading = false;
    });
  }

  async createBasicContainer(use3d = false) {
    this.pendingUse3d = use3d;
    await this.userService.getCurrentUser()
    .then((response: any) => { this.user = response; })
    .catch(() => { this.user = undefined; });

    if (!this.user) {
      this.showModal(this.loginModal1);
      return;
    }
    this.templateLoading = true;
    this.getTemplate()
    .then(response => {
      this.addCustomerInfo(response)
      .then(customer => {
        this.createBasicDesign(customer)
        .then(design => {
          this.goToBuilder(design, use3d);
        })
        .catch(() => {
          this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
          this.templateLoading = false;
        });
      })
      .catch(error => {
        this.productData = {
          Category: this.categoryCode,
          paperType: this.paperTypeId,
          NewDesignID: 0,
          options: this.options,
          length: this.length,
          width: this.width,
          depth: this.depth,
          gloss: this.gloss,
          luxe: this.luxe,
          twoSided: this.twoSided,
          insideOnly: this.insideOnly,
          print: this.printing,
          material: this.material,
          finish: this.finish,
          categoryName: this.categoryName,
          quantity: this.isTissue ? ((this.selectedPrice?.quantity??1)  / 100) : (this.selectedPrice?.quantity??1) ,
          outerMaterial: this.outerMaterial,
          innerMaterial: this.innerMaterial,
          continuedProject: false,
          shape: this.shape,
          rush: this.expedited,
          customSizeEntered: this.customSizeEntered,
          customSizeActive: this.customSizeActive,
          lengthWhole: this.lengthWhole,
          widthWhole: this.widthWhole,
          depthWhole: this.depthWhole,
          lengthFraction: this.lengthFraction,
          widthFraction: this.widthFraction,
          depthFraction: this.depthFraction,
          username: 'test@companybox.com',
          password: 'Password1!'
        };
        this.showModal(this.loginModal1);
        this.templateLoading = false;
      });
    })
    .catch(() => {
      this.templateLoading = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }
  get uploadDesignDisabled(): boolean {
    return this.prices.length === 0 || this.customQuantityViolation;
  }

  async createAdvancedContainer() {
    await this.userService.getCurrentUser()
    .then((response: any) => { this.user = response; })
    .catch(() => { this.user = undefined; });

    if (!this.user) {
      this.showModal(this.loginModal);
      return;
    }
    this.templateLoading = true;
    this.getTemplate()
    .then(response => {
      this.addCustomerInfo(response)
      .then(customer => {
        this.createAdvancedDesign(customer)
        .then(design => {
          this.templateLoading = false;
          this.goToUploadDesign(design);
        })
        .catch(() => {
          this.templateLoading = false;
          this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
        });
      })
      .catch(error => {
        this.productData = {
          Category: this.categoryCode,
          paperType: this.paperTypeId,
          NewDesignID: 0,
          options: this.options,
          length: this.length,
          width: this.width,
          depth: this.depth,
          gloss: this.gloss,
          luxe: this.luxe,
          twoSided: this.twoSided,
          insideOnly: this.insideOnly,
          print: this.printing,
          material: this.material,
          finish: this.finish,
          categoryName: this.categoryName,
          quantity: this.isTissue ? ((this.selectedPrice?.quantity??1) ??1 / 100) : (this.selectedPrice?.quantity??1) ,
          outerMaterial: this.outerMaterial,
          innerMaterial: this.innerMaterial,
          continuedProject: false,
          shape: this.shape,
          rush: this.expedited,
          customSizeEntered: this.customSizeEntered,
          customSizeActive: this.customSizeActive,
          lengthWhole: this.lengthWhole,
          widthWhole: this.widthWhole,
          depthWhole: this.depthWhole,
          lengthFraction: this.lengthFraction,
          widthFraction: this.widthFraction,
          depthFraction: this.depthFraction,
          username: 'test@companybox.com',
          password: 'Password1!'
        };
        this.showModal(this.loginModal);
        this.templateLoading = false;
      });
    })
    .catch(() => {
      this.templateLoading = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }

  addPartitionToCart() {
    const boardType = 'e';
    const paperType = this.material.toLowerCase() === 'kraft' ? 'kraft' : 'white';
    console.log(paperType);
    this.checkoutService.createPartition(paperType, boardType, this.length, this.width,
      this.depth, this.cellLength, this.cellWidth, this.lengthSlots, this.widthSlots, (this.selectedPrice?.quantity??1) , false)
    .then((response: any) => {
      this.boxService.getType('PARTE')
      .then((type: any) => {
        const lineItem = this.checkoutService.createPartitionLineItem(response, type);

        this.checkoutService.addToCart(lineItem)
        .then(() => {
          this.router.navigate(['/cart']);
        })
        .catch(() => {
          this.templateLoading = false;
          this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
        });
      })
      .catch(() => {
        this.templateLoading = false;
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    })
    .catch(() => {
      this.templateLoading = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });

  }
  addCrinkleToCart() {
    const quantity = this.selectedPrice?.quantity ?? 1;
    const color = this.normalizeCrinkleColor(this.selectedPreset?.label ?? '');
    this.checkoutService.createCrinkle(quantity, color)
    .then((response: any) => {
      this.boxService.getType('CKLP')
      .then((type: any) => {
        const lineItem = this.checkoutService.createCrinkleLineItem(response, type);

        this.checkoutService.addToCart(lineItem)
        .then(() => {
          this.router.navigate(['/cart']);
        })
        .catch(() => {
          this.templateLoading = false;
          this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
        });
      })
      .catch(() => {
        this.templateLoading = false;
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    })
    .catch(() => {
      this.templateLoading = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });

  }

  addToCart() {
    this.modal?.hide();
    this.paperTypeId = this.resolvePaperTypeId();
    this.gloss = this.finish === 'Gloss';
    if (this.subcategoryCode.startsWith('SNAP2S')) {
      this.options = 'superseal';
    }

    this.templateLoading = true;
    this.getTemplate()
    .then((response: any) => {
      this.boxService.getType(this.boxCode??'')
      .then((type: any) => {
        this.checkoutService.createNoprint(response.containerName,
          this.boxCode, this.boardStrength?.strength,
          this.getPaperTypeID(this.outerMaterial), this.getPaperTypeID(this.innerMaterial), this.gloss, this.luxe, undefined,
          this.length, this.width, this.depth, this.preset,
          this.twoSided, this.insideOnly, this.expedited, this.options, this.quantity, this.noprint)
        .then((responses: any) => {
            responses.quantity = (this.selectedPrice?.quantity??1) ;
            const lineItem = this.checkoutService.createLineItem(responses.containerName, type, responses);
            // this.boxService.getType(this.boxCode).then(type => {
            // const lineItem = this.checkoutService.createNoprintLineItem( response, type);
            this.checkoutService.addToCart(lineItem)
            .then(() => {
              this.router.navigate(['/cart']);
            })
            .catch(() => {
              this.templateLoading = false;
              this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
            });
          })
        .catch(() => {
          this.templateLoading = false;
          this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
        });
      })
      .catch(() => {
        this.templateLoading = false;
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    })
    .catch(() => {
      this.templateLoading = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });
  }

  async saveProject() {
    await this.userService.getCurrentUser()
    .then((response: any) => { this.user = response; })
    .catch(() => { this.user = undefined; });

    if (!this.user) {
      this.showModal(this.loginToSaveModal);
      return;
    }

    let template: any;
    await this.getTemplate()
    .then(response => {
      template = response;
    })
    .catch(() => {
      this.templateLoading = false;
      this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
    });

    this.design = {
      customerId: this.user?.shopifyId,
      container: template.containerName,
      type: 'BASIC',
      outside: '',
      inside: '',
      twoSided: this.twoSided,
      insideOnly: this.insideOnly,
      name: 'My Box',
      dimensions: template.dimensions.replace(/\s/g, ''),
      subcategory: template.boxType.subcategory,
      boardType: template.boardType,
      boardStrength: template.boardStrength.strength,
      kraftType: this.getPaperTypeID(this.material),
      preset: template.preset,
      gloss: this.gloss,
      luxe: this.luxe,
      quantity: this.quantity,
      optionsArray: [],
      options: ''
    };


    this.designService.getDesign(this.user?.id??0, template.containerName)
    .then((response: any) => {
      this.design = {...response, ...this.design};
      this.designService.updateDesign(this.user?.id??0, this.design)
      .then(() => {
        this.router.navigate(['/continue-project']);
      })
      .catch(() => {
        this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
      });
    })
    .catch((error: { status: number; }) => {
      if (error.status === 404) {
        this.designService.createDesign(this.user?.id??0, this.design)
        .then((response: any) => {
          this.router.navigate(['/continue-project']);
        })
        .catch(() => {
          this.bsModalService.show(ConfirmationModalComponent).content?.showModal(ERROR_BODY, ERROR_TITLE, { showCloseButton: false });
        });
      }
    });
  }

  createAdvancedDesign(resolveObj: any) {
    const design = {
      customerId: resolveObj.customerId,
      container: resolveObj.containerName,
      type: 'ADVANCED',
      name: 'My Box',
      dimensions: resolveObj.dimensions.replace(/\s/g, ''),
      boardType: resolveObj.boxCode,
      boardStrength: this.isOtherProduct ? '32' : resolveObj.boardStrength.strength,
      kraftType: this.getPaperTypeID(this.outerMaterial),
      secondaryKraftType: this.getPaperTypeID(this.innerMaterial),
      preset: resolveObj.preset,
      filename: new Date().getTime().toString(), // Per ESKO's request, use epoch as filename.
      gloss: this.gloss ? this.gloss : 'false',
      luxe: this.luxe,
      rush: this.expedited,
      twoSided: this.twoSided,
      insideOnly: this.insideOnly,
    };
    // tslint:disable-next-line: no-shadowed-variable
    return new Promise((resolve, reject) => {
      this.designService.createDesign(resolveObj.userId, design)
      .then((savedDesign: any) => {
        resolveObj.design = savedDesign;
        resolve(resolveObj);
      })
      .catch((error: any) => {
        console.log('Unable to create design', error);
        reject(error);
      });
    });
  }

  createBasicDesign(resolveObj: any) {
    const design = {
      customerId: resolveObj.customerId,
      container: resolveObj.containerName,
      type: 'ADVANCED',
      name: 'My Box',
      dimensions: resolveObj.dimensions.replace(/\s/g, ''),
      boardType: resolveObj.boxCode,
      boardStrength: this.isOtherProduct ? '32' : resolveObj.boardStrength.strength,
      kraftType: this.getPaperTypeID(this.outerMaterial),
      secondaryKraftType: this.getPaperTypeID(this.innerMaterial),
      preset: resolveObj.preset,
      filename: new Date().getTime().toString(), // Per ESKO's request, use epoch as filename.
      gloss: this.gloss ? this.gloss : 'false',
      luxe: this.luxe,
      rush: this.expedited,
      twoSided: this.twoSided,
      insideOnly: this.insideOnly,
    };
    // tslint:disable-next-line: no-shadowed-variable
    return new Promise((resolve, reject) => {
      this.designService.createDesign(resolveObj.userId, design)
      .then((savedDesign: any) => {
        resolveObj.basicdesign = savedDesign;
        resolve(resolveObj);
      })
      .catch((error: any) => {
        console.log('Unable to create design', error);
        reject(error);
      });
    });
  }
  addCustomerInfo(resolveObj: any) {
    return new Promise((resolve, reject) => {
      this.userService.getCurrentUser()
      .then((user: any) => {
        resolveObj.userId = user.id;
        resolveObj.customerId = user.shopifyId;
        resolveObj.firstName = user.firstName;
        resolveObj.lastName = user.lastName;
        resolveObj.email = user.username;
        resolve(resolveObj);
      }, (error: any) => {
        reject(error);
      });
    });
  }

  getTemplate(downloadOnly = false): Promise<any> {
    if (this.subcategoryCode.toLowerCase() === 'tape') {
      this.width = 3;
    }

    const boxName = this.subcategoryCode.toLowerCase() === 'dhc'
      ? this.box?.boxType?.name
      : this.isTape || this.isTissue
        ? this.type
        : this.selectedPreset?.type?.name;

    const input: BoxTemplateInput = {
      subcategoryCode: this.subcategoryCode,
      boxCode: this.boxCode ?? '',
      length: this.length,
      width: this.width,
      depth: this.depth,
      kraftType: this.getPaperTypeID(this.material),
      boardStrength: this.selectedBoardStrength,
      boardType: this.selectedBoardType,
      preset: this.selectedPreset !== undefined,
      boxName,
      selectedVariant: this.selectedVariant,
      shape: this.shape,
      isTape: this.isTape,
      isTissue: this.isTissue,
      isLabel: this.isLabel,
    };

    return this.projectService.getTemplate(input, downloadOnly);
  }

  async goToBuilder(product: any, use3d = false) {

    const productDetails = {
      Category: this.categoryCode,
      Subcategory: product.boxType.aeCode,
      Code: this.isLabel ? 'label' : product.boxType.code,
      BoardStrength: product.boardStrength ? product.boardStrength.strength : null,
      ContainerName: product.containerName,
      paperType: this.paperTypeId,
      NewDesignID: 0,
      BoxDimensions: product.dimensions,
      options: this.options,
      Preset: product.preset,
      gloss: this.gloss,
      luxe: this.luxe,
      twoSided: this.twoSided,
      insideOnly: this.insideOnly,
      print: this.printing,
      material: this.material,
      finish: this.finish,
      categoryName: this.categoryName ? this.categoryName : this.subcategoryCode.toLowerCase() === 'tape' ? 'Tape' :
        this.subcategoryCode.toLowerCase() === 'lbl' ? 'Label' : 'Tissue',
      quantity: this.isTissue ? ((this.selectedPrice?.quantity??1) ??0 / 100) : (this.selectedPrice?.quantity??1) ,
      outerMaterial: this.outerMaterial,
      innerMaterial: this.innerMaterial,
      continuedProject: false,
      shape: this.shape,
      rush: this.expedited
    };
    this.navigationService.setContainerName(product.containerName);
    this.navigationService.setProductDetails(productDetails);
    this.router.navigate([use3d ? '/design-3d' : '/design', this.categoryCode, this.subcategoryCode, productDetails]);
  }

  private isCrinkleProduct(code?: string, name?: string) {
    const normalizedCode = (code ?? '').toLowerCase();
    const normalizedName = (name ?? '').toLowerCase();
    return normalizedCode === 'cklp' || normalizedCode === 'crinkle' || normalizedName.includes('crinkle');
  }

  private normalizeCrinkleColor(label: string) {
    const normalized = label.toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    const colorMap: Record<string, string> = {
      'lightpink': 'light pink',
      'light pink': 'light pink',
      'limegreen': 'lime green',
      'lime green': 'lime green',
      'royalblue': 'royal blue',
      'royal blue': 'royal blue',
      'forestgreen': 'forest green',
      'forest green': 'forest green',
      'kraft': 'kraft',
      'red': 'red',
      'blue': 'blue',
      'black': 'black',
      'yellow': 'yellow',
      'white': 'white',
      'ivory': 'ivory',
    };

    if (colorMap[normalized]) {
      return colorMap[normalized];
    }

    const matchedKey = Object.keys(colorMap).find((key) => normalized.includes(key));
    return matchedKey ? colorMap[matchedKey] : normalized;
  }

  cancel() {
    this.modal?.hide();
  }
}
